<template>
  <div>
    <div
      v-for="(button, i) in buttons"
      :key="i + Math.random()"
      class="mx-2 my-3"
    >
      <v-btn
        block
        :color="button.color"
        dark
        @click="$emit('button-clicked', button.event)"
      >
        <v-icon>{{ button.icon }}</v-icon
        >{{ button.label }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: ["buttons"],
};
</script>

<style></style>
